import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { settingsAPI } from '../services/api';
import { useAuth } from './AuthContext';
import { getBusinessProfile } from '../businessProfiles';

const SettingsContext = createContext(null);

/**
 * The signed-in user's settings (company info, business type, services toggle),
 * loaded once and shared, so every screen adapts to the business profile.
 */
export const SettingsProvider = ({ children }) => {
    const { user } = useAuth();
    const [settings, setSettings] = useState(null);

    const refresh = useCallback(async () => {
        try {
            setSettings(await settingsAPI.get());
        } catch (error) {
            console.error('Failed to load settings:', error);
        }
    }, []);

    useEffect(() => {
        if (user) refresh();
        else setSettings(null);
    }, [user, refresh]);

    const businessType = settings?.businessType || 'GENERAL';
    const value = {
        settings,
        refresh,
        businessType,
        profile: getBusinessProfile(businessType),
        servicesEnabled: Boolean(settings?.servicesEnabled),
    };

    return <SettingsContext.Provider value={value}>{children}</SettingsContext.Provider>;
};

export const useSettings = () => {
    const context = useContext(SettingsContext);
    if (!context) throw new Error('useSettings must be used within a SettingsProvider');
    return context;
};
